import { apiCall } from '@/lib/api';
import { createMutation, useQueryClient } from '@tanstack/solid-query';
import { type UpdateMeBody, updateMe } from '@uchat-team-management/shared';

export const useUpdateMe = () => {
  const qc = useQueryClient();
  return createMutation(() => ({
    mutationFn: (body: UpdateMeBody) => apiCall(updateMe, { body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['auth', 'me'] }),
  }));
};
